import { Defaults } from '@pbt/pbt-ui-components'
import i18n from '../locales/i18n'

export const USER_DEACTIVATED_MESSAGE = i18n.t(
  'Errors:USER_DEACTIVATED_MESSAGE',
  {
    supportEmail: Defaults.SUPPORT_EMAIL,
  },
)
